export default __webpack_public_path__ + "8d638f20d63f861af0253e66baf90c62.png";